import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { EncryptionService } from '@app/core/services';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  firstName: string;
  lastName: string;
  email: string;
  constructor(private encryptService: EncryptionService) {}

  /* Setting up User tokens to Session Storage */
  setUserData(response) {
    this.setEmail(response.email);
    this.setUserId(response.id);
    this.setFirstName(response.first_name);
    this.setLastName(response.last_name);
  }

  /* Removing tokens from Local and Session storage's */
  expireSession() {
    let theme: any = this.getTheme();
    localStorage.clear();
    sessionStorage.clear();
    this.setTheme(theme);
  }

  /* Get user first and last name and email from Session Storage */
  getUserName() {
    try {
      let userName: any;
      let firstName = this.getFirstName();
      let lastName = this.getLastName();
      let email = this.getEmail();
      if (firstName && firstName != 'null' && lastName && lastName != 'null') {
        userName = `${firstName} ${lastName}`;
      } else {
        userName = email;
      }
      return userName;
    } catch (error) {
      return '';
    }
  }

  /* Setting up tokens for Local Storage */
  /* Setting up encrypted token to Local Storage as 'token' */
  setToken(token: any) {
    localStorage.setItem('token', this.encryptService.set(environment.secret_key, token));
  }
  /* Setting up application tokens for Local Storage */
  /* Setting up encrypted token to Local Storage as 'token' */
  setApplicationToken(token: any) {
    localStorage.setItem(
      'applicationToken',
      this.encryptService.set(environment.secret_key, token)
    );
  }

  /**
   * Get application token
   */
  getApplicationToken() {
    return this.encryptService.get(
      environment.secret_key,
      localStorage.getItem('applicationToken')
    );
  }

  /* Setting up tokens for Local Storage */
  /* Setting up encrypted token to Local Storage as 'token' */
  setMFAToken(token: any) {
    localStorage.setItem('mfa_token', this.encryptService.set(environment.secret_key, token));
  }

  /**
   * Get MFA token
   */
  getMFAToken() {
    return this.encryptService.get(environment.secret_key, localStorage.getItem('mfa_token'));
  }

  /* Setting up tokens for Session Storage */
  /* Setting up token to Session Storage as 'firstName' */
  setFirstName(name) {
    sessionStorage.setItem('firstName', name);
    this.firstName = name;
  }

  /* Setting up token to Session Storage as 'lastName' */
  setLastName(name) {
    sessionStorage.setItem('lastName', name);
    this.lastName = name;
  }

  /* Setting up encrypted token to Session Storage as 'email' */
  setEmail(email) {
    sessionStorage.setItem('email', this.encryptService.set(environment.secret_key, email));
  }

  /* Setting up encrypted token to Session Storage as 'userId' */
  setUserId(id) {
    sessionStorage.setItem('userId', this.encryptService.set(environment.secret_key, id));
  }

  /* Setting up encrypted token to Session Storage as 'theme' */
  setTheme(data) {
    localStorage.setItem('theme', data);
  }

  /** Get encrypted 'theme' and decrypting it form Session Storage */
  getTheme() {
    return localStorage.getItem('theme');
  }

  getToken() {
    return this.encryptService.get(environment.secret_key, localStorage.getItem('token'));
  }

  /* Getting tokens from Local Storage */
  /* Get encrypted 'token' and decrypting it form Local Storage */
  getEncryptedToken() {
    return this.encryptService.get(environment.secret_key, this.getToken());
  }

  /* Getting tokens from Session Storage */
  /* Get 'firstName' form Session Storage */
  getFirstName() {
    return sessionStorage.getItem('firstName');
  }

  /* Get 'lastName' form Session Storage */
  getLastName() {
    return sessionStorage.getItem('lastName');
  }

  /* Get encrypted 'email' and decrypting it form Session Storage */
  getEmail() {
    let token = sessionStorage.getItem('email');
    return this.encryptService.get(environment.secret_key, token);
  }

  /* Get encrypted 'userId' and decrypting it form Session Storage */
  getUserId() {
    let token = sessionStorage.getItem('userId');
    return this.encryptService.get(environment.secret_key, token);
  }

  /**
   * Get MFA Token
   */
  getCustomMfaToken() {
    let mfaTokenDetails: any = localStorage.getItem(
      `@@auth0spajs@@::${environment.auth.client_id}::https://${environment.auth.auth_domain}/mfa/::openid profile email sso:admin_all offline_access enroll read:authenticators remove:authenticators`
    );
    let parsedTokenDetails: any = JSON.parse(mfaTokenDetails);
    return parsedTokenDetails.body.access_token;
  }
}
